module.exports = __webpack_public_path__ + "img/flight-deck-layout.28560c35.jpg";